import { useEffect } from 'react';
import { isIOS } from 'react-device-detect'

/**
 * Hook that detects iPad devices and applies overscroll-behavior-y: none
 * to the html element only when running on iPad
 */
export const useIPadOverscroll = () => {
  useEffect(() => {
    if (isIOS) {
      // Apply overscroll-behavior-y: none to html element
      const htmlElement = document.documentElement;
      htmlElement.style.overscrollBehaviorY = 'none';

      // Cleanup function to remove the style when component unmounts
      return () => {
        htmlElement.style.overscrollBehaviorY = '';
      };
    }
  }, []);
};
